import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function globalLogout() {
  const channel = new BroadcastChannel('falconsend_channel');
  channel.postMessage({type:BCEventType_Logout})
}

export function globalSetUser(user) {
  const channel = new BroadcastChannel('falconsend_channel');
  channel.postMessage({type:BCEventType_SetUser, data:user})
}

function checkAuthToken(name) {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get(name);
  if (token) {
    localStorage.setItem(name, token);
  }
  return token;
}

interface BroadcastChannelEvent {
  type:string
  data:any
}

const BCEventType_Logout = "logout";
const BCEventType_SetUser = "setUser";

export function ProtectedRoute() {
  const { user, login, logout, loading } = useAuth();
  const channel = new BroadcastChannel('falconsend_channel');

  channel.onmessage = (event) => {
    const e = event.data as BroadcastChannelEvent;
    console.log('Message received:', event.data);
    if (e.type == BCEventType_Logout) {
      logout();
      <Navigate to="/login" replace />
    }
    if (e.type == BCEventType_SetUser) {
      login(e.data);
    }
  };

  if (loading) {
    return <div className="flex bg-grey-100 justify-center items-center h-screen">Loading...</div>;
  }

  console.log('Protected route');

  if (!user) {
    const h = window.location.href;
    const origUrl = h.substring(h.replace("//", "").indexOf("/") + 2)
    if (origUrl != '/login' && origUrl != '/forgot-password') {
      localStorage.setItem("originalUrl", h);
    }

    // register token
    if (checkAuthToken("registerToken")) {
      channel.postMessage({type:BCEventType_Logout})
      return <Navigate to="/signup?workflow=setup_password" replace />;
    } else 
      // forgot password token
      if (checkAuthToken("resetPasswordToken")) {
        channel.postMessage({type:BCEventType_Logout})
      return <Navigate to="/signup?workflow=reset_password" replace />;
    } else {
      // If user is not authenticated, redirect to login page
      return <Navigate to="/login" replace />;
    }
  }

  // If authenticated, render the child routes
  return <Outlet />;
};